import { getBuyOverlay } from './BuyOverlay'

class StickyBuyBar {
    constructor(titleDetailComponentElement) {
        /* HTML Elements */
        this.titleDetailComponentElement = titleDetailComponentElement
        this.headingElement = document.querySelector('#heading')
        this.primaryBuyButtonElement = this.titleDetailComponentElement.querySelector('.primary-buy-button')
        this.stickyBuyBarElement = this.titleDetailComponentElement.querySelector('.sticky-buy-bar')
        this.authorElement = this.titleDetailComponentElement.querySelector('.sticky-buy-author')
        this.titleElement = this.titleDetailComponentElement.querySelector('.sticky-buy-title')
        this.variationDropdownElement = this.stickyBuyBarElement
            ? this.stickyBuyBarElement.querySelector('.variation-dropdown')
            : null
        this.variationTextElement = this.variationDropdownElement
            ? this.variationDropdownElement.querySelector('.variation-dropdown-text')
            : null
        this.variationOptionElements = this.stickyBuyBarElement
            ? this.stickyBuyBarElement.querySelectorAll('.variation-dropdown-option')
            : []
        this.buyButtonElement = this.titleDetailComponentElement.querySelector('.sticky-buy-button')

        /* Components */
        this.buyOverlay = getBuyOverlay(this.titleDetailComponentElement)

        /* State */
        this.selectedVariationIndex = this.stickyBuyBarElement
            ? Number(this.stickyBuyBarElement.dataset.currentVariationIndex)
            : null
        this.scrollAnimationFrameId = null
        this.headingResizeObserver = null
        this.isStickyVisible = false
        this.hideStickyBarOffset = 40
    }

    init() {
        if (!this.primaryBuyButtonElement || !this.stickyBuyBarElement || !this.buyOverlay) {
            return
        }

        this.copyBookInformation()
        this.updateSelectedVariation(this.selectedVariationIndex)
        this.initEventListeners()
        this.initHeadingResizeObserver()
        this.updateVisibility()
    }

    copyBookInformation() {
        let authorElement = this.titleDetailComponentElement.querySelector('.hero .author')
        let titleElement = this.titleDetailComponentElement.querySelector('.hero .title')

        if (authorElement) {
            this.authorElement.innerHTML = authorElement.innerHTML
        }

        if (titleElement) {
            this.titleElement.innerHTML = titleElement.innerHTML
        }
    }

    initEventListeners() {
        window.addEventListener('scroll', () => this.handleScrollEvent(), {passive: true})
        window.addEventListener('resize', () => this.handleScrollEvent())

        this.variationOptionElements.forEach((variationOptionElement) => {
            variationOptionElement.addEventListener('click', (event) => {
                this.handleVariationOptionClickEvent(event)
            })
        })

        this.transitionEndEventHandler = (event) => this.handleTransitionEndEvent(event)
        this.stickyBuyBarElement.addEventListener('transitionend', this.transitionEndEventHandler)
    }

    initHeadingResizeObserver() {
        if (!this.headingElement) {
            return
        }

        this.headingResizeObserver = new ResizeObserver(() => this.handleScrollEvent())
        this.headingResizeObserver.observe(this.headingElement)
    }

    handleScrollEvent() {
        if (this.scrollAnimationFrameId != null) {
            return
        }

        this.scrollAnimationFrameId = requestAnimationFrame(() => {
            this.updateVisibility()
            this.scrollAnimationFrameId = null
        })
    }

    handleVariationOptionClickEvent(event) {
        this.updateSelectedVariation(Number(event.currentTarget.dataset.variationIndex))
    }

    updateVisibility() {
        let headingBottom = this.headingElement
            ? this.headingElement.getBoundingClientRect().bottom
            : 0
        let primaryBuyButtonBottom = this.primaryBuyButtonElement.getBoundingClientRect().bottom
        let shouldShowStickyBar = this.isStickyVisible
            ? primaryBuyButtonBottom <= headingBottom + this.hideStickyBarOffset
            : primaryBuyButtonBottom <= headingBottom

        this.setStickyVisible(shouldShowStickyBar)
    }

    setStickyVisible(visible) {
        if (this.isStickyVisible === visible) {
            return
        }

        this.isStickyVisible = visible

        if (visible) {
            this.stickyBuyBarElement.classList.remove('is-settled')
            this.stickyBuyBarElement.classList.add('visible')
            return
        }

        this.stickyBuyBarElement.classList.remove('is-settled')
        this.stickyBuyBarElement.classList.remove('visible')
    }

    handleTransitionEndEvent(event) {
        if (event.target !== this.stickyBuyBarElement || event.propertyName !== 'transform') {
            return
        }

        if (this.isStickyVisible) {
            this.stickyBuyBarElement.classList.add('is-settled')
        }
    }

    updateSelectedVariation(variationIndex) {
        let selectedPanelElement = this.buyOverlay.getSourcePanelElement(variationIndex)
        let selectedOptionElement = this.getVariationOptionElement(variationIndex)

        if (!selectedPanelElement) {
            return
        }

        this.selectedVariationIndex = variationIndex
        this.stickyBuyBarElement.dataset.currentVariationIndex = variationIndex

        if (this.variationTextElement) {
            this.variationTextElement.textContent = selectedOptionElement
                ? selectedOptionElement.textContent.trim()
                : selectedPanelElement.dataset.variationLabel
        }

        this.buyButtonElement.textContent = selectedPanelElement.dataset.buttonLabel
        this.buyButtonElement.dataset.variationIndex = variationIndex
        this.buyButtonElement.dataset.ean = selectedPanelElement.dataset.ean

        this.variationOptionElements.forEach((variationOptionElement) => {
            let isSelected = Number(variationOptionElement.dataset.variationIndex) === variationIndex
            variationOptionElement.hidden = isSelected
        })
    }

    getVariationOptionElement(variationIndex) {
        return Array.from(this.variationOptionElements).find((optionElement) => {
            return Number(optionElement.dataset.variationIndex) === variationIndex
        })
    }
}

export default function init() {
    const titleDetailComponentElements = document.querySelectorAll('.title-detail-v2-component')

    titleDetailComponentElements.forEach(titleDetailComponentElement => {
        const stickyBuyBar = new StickyBuyBar(titleDetailComponentElement)
        stickyBuyBar.init()
    })
}
